import { useRef, useState } from "react";
import { Autocomplete, Grid, TextField } from "../../../../components";
import { value } from "../../../../helpers";
import { ProdutosService } from "../../../../services";
import { timeoutBuscaAutocomplete } from "../../../../utils";

const produtosService = new ProdutosService();

const FiltroImpressaoProduto = ({
  produtoSelecionado,
  setProdutoSelecionado,
  listaOpcoesProdutos,
  setListaOpcoesProdutos,
  setFiltroImpressao,
  inputErros
}) => {
  const inputRef = useRef();
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);

  const buscarProdutos = (filtros) => {
    const filtro = {
      ...filtros,
      orderBy: "codigo",
      order: "asc",
      ativado: true,
      limite: 20,
    };
    produtosService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setListaOpcoesProdutos(result.data.rows);
      } else {
        setListaOpcoesProdutos([]);
      }
      setLoadingAutoComplete(false);
    });
  };

  const onInputChangeProdutos = (event) => {
    const eventValue = event.target?.value.includes(",")
      ? event.target?.value.split(",")[0]
      : event.target?.value;
    if (
      event.key === "Backspace" &&
      inputRef.current === document.activeElement &&
      eventValue === ""
    ) {
      setListaOpcoesProdutos([]);
    }
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      setLoadingAutoComplete(true);
      const filtros = {
        codigo: eventValue,
        descricao: eventValue,
      };
      timeoutBuscaAutocomplete(buscarProdutos(filtros));
    }
  }

  const handleChangeAutocompleteProduto = (event, value) => {
    setProdutoSelecionado(value);
    setFiltroImpressao((prevState) => ({
      ...prevState,
      produtoId: value?.id
    }));
  }

  return (
    <>
    <Grid item xs={8}>
      <Autocomplete
        required
        id="produtoId"
        name="produtoId"
        options={listaOpcoesProdutos}
        loading={loadingAutoComplete}
        noOptionsText="Sem opções"
        autoHighlight
        getOptionLabel={(option) =>
          option?.codigo && option?.descricao
            ? `${option.codigo} - ${option.descricao}`
            : ""
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Produto"
            margin="normal"
            required
            onKeyDown={(e) => onInputChangeProdutos(e)}
            inputRef={inputRef}
            InputProps={{
              ...params.InputProps,
            }}
            error={inputErros.get("produtoId")}
          />
        )}
        onChange={handleChangeAutocompleteProduto}
        value={value.autoComplete(listaOpcoesProdutos, produtoSelecionado?.id)}
      />
    </Grid>
    </>
  );
};

export default FiltroImpressaoProduto;
